import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { SettingsLayout } from 'src/components/app-ui'
import { coursePath } from '../tabs'
import GeneralSection from './general-section'
import WebhookSection from './webhook-section'

/**
 * `value` is the `settings/:subPage` URL segment. Course language lives in
 * General; interface texts move to Workspace > Language.
 */
const SECTIONS = [
  {
    value: 'general',
    label: 'General',
    icon: 'tabler:settings',
    Component: GeneralSection,
  },
  {
    value: 'webhook',
    label: 'Webhook',
    icon: 'tabler:webhook',
    Component: WebhookSection,
  },
]

const SettingsTab = () => {
  const history = useHistory()
  const { id, subPage } = useParams()
  const active =
    SECTIONS.find(section => section.value === subPage) || SECTIONS[0]
  const { Component } = active

  return (
    <SettingsLayout
      items={SECTIONS}
      value={active.value}
      onChange={value => history.push(coursePath(id, 'settings', value))}
    >
      <Component />
    </SettingsLayout>
  )
}

export default SettingsTab
